// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HSq16jzmSmlS2i {
  padding: 10px;
}
.HSq16jzmSmlS2i .rnkz56Fvjvm0Ac {
  font-weight: 400;
}
.HSq16jzmSmlS2i .GcoPHB3RaU5f2C {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: 600;
  margin-top: 25px;
}
.HSq16jzmSmlS2i .p_Flfg3LdJd_ue {
  font-weight: 400;
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.HSq16jzmSmlS2i .wKl0Mn5gAjJA5I {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: 600;
  overflow-wrap: break-word;
  font-size: 26px;
}
.HSq16jzmSmlS2i .mM2rTchnFLN3yY,
.HSq16jzmSmlS2i .LH0kP6buCdE2K4,
.HSq16jzmSmlS2i .UJ72n25LY19lkR {
  font-weight: 400;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.HSq16jzmSmlS2i .LH0kP6buCdE2K4 {
  margin: 32px 25px 25px 30px;
}
.HSq16jzmSmlS2i:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.HSq16jzmSmlS2i:nth-last-child(2) .GcoPHB3RaU5f2C {
  margin-top: 3px;
}
.HSq16jzmSmlS2i:nth-last-child(2)::before {
  margin-top: 20px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  content: attr(data-value);
  position: relative;
  top: -15px;
  width: 85px;
  height: 24px;
  padding: 5px;
  border-radius: 2px;
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCell": `HSq16jzmSmlS2i`,
	"purchase": `rnkz56Fvjvm0Ac`,
	"name": `GcoPHB3RaU5f2C`,
	"info": `p_Flfg3LdJd_ue`,
	"price": `wKl0Mn5gAjJA5I`,
	"frequency": `mM2rTchnFLN3yY`,
	"pricingVaries": `LH0kP6buCdE2K4`,
	"currentPlan": `UJ72n25LY19lkR`
};
export default ___CSS_LOADER_EXPORT___;
